import React, { useMemo } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Card, CardBody, Col, Row } from "reactstrap"
import CustomersIcon from "../../../assets/images/icons/customers.png"
import AddCustomersIcon from "../../../assets/images/icons/add-customer.png"
import GoogleMap from "../../../assets/images/icons/google-maps.png"
import SaveMoney from "../../../assets/images/icons/save-money.png"
import arrow from "../../../assets/images/icons/arrow.png"
import ReactApexChart from "react-apexcharts"
import { ApexOptions } from "apexcharts"
import CustomerDistribution from "./components/CustomerDistribution"
import Disputes from "./components/Disputes"
import PurchaseRate from "./components/PurchaseRate"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

export const Customers = () => {
  const { t } = useTranslation()

  const apexearningChartColors = ["#556ee6", "#34c38f", "#f57224", "#f57224"]
  const dataCard: {
    title: string
    total: number | string
    icon: string
    color: string
    path?: string
  }[] = useMemo(() => {
    return [
      {
        title: t("customers_totalCustomers"),
        total: 15,
        icon: CustomersIcon,
        color: "primary",
      },
      {
        title: t("customers_churnRate"),
        total: "15%",
        icon: arrow,
        color: "primary",
      },
      {
        title: t("customers_newThisMonth"),
        total: 8,
        icon: AddCustomersIcon,
        color: "cyan",
        path: "new-this-month",
      },
      {
        title: t("customers_activeArea"),
        total: 12,
        icon: GoogleMap,
        color: "light",
        path: "area-active",
      },
      {
        title: t("customers_customersBundles"),
        total: 5,
        icon: SaveMoney,
        color: "danger",
        path: "bundles",
      },
    ]
  }, [t])

  const series = [
    {
      name: t("customers_orders"),
      data: [31, 40, 36, 51, 49, 72, 69, 56],
    },
  ]

  const options: ApexOptions = {
    chart: {
      toolbar: {
        show: false,
      },
      dropShadow: {
        enabled: true,
        color: "#000",
        top: 18,
        left: 7,
        blur: 8,
        opacity: 0.2,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: apexearningChartColors,
    stroke: {
      curve: "smooth",
      width: 3,
    },
    xaxis: {
      categories: [
        "6-9 AM",
        "9-12 AM",
        "12-3 PM",
        "3-6 PM",
        "6-9 PM",
        "9-12 PM",
        "12-3 AM",
        "3-6 AM"
      ],
    },
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("customers_customers")}
        />

        <Row className="mt-2" style={{ rowGap: "1rem" }}>
          {dataCard.map((report, key) => (
            // <Col md="4" lg="3" key={"_col_" + key}>
            <Col
              md="4"
              lg="2.4"
              key={"_col_" + key}
              className="col-lg-5ths p-2"
              style={{ height: "fit-content" }}
            >
              <Link to={report.path ? report.path : "#"}>
                <Card
                  className="mini-stats-wid shadow-md h-100"
                  style={report.path ? { backgroundColor: "#095BA814" } : {}}
                >
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium text-capitalize">
                          {report.title}
                        </p>
                        <h4 className="mb-0">{report.total}</h4>
                      </div>
                      <div
                        className={`d-flex justify-content-center align-items-center avatar-sm rounded-circle  align-self-center mini-stat-icon bg-${report.color}-30`}
                      >
                        <p className="rounded-circle m-0">
                          <img src={report.icon} alt={report.title} />
                        </p>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
        <Row className="mt-4" style={{ rowGap: "1.5rem" }}>
          <Col xl="8">
            <Card className="shadow-md h-100">
              <CardBody>
                <h4 className="text-capitalize font-size-">
                  {t("customers_preferredOrderTimes")}
                </h4>

                <div id="line-chart" dir="ltr">
                  <ReactApexChart
                    series={series}
                    options={options}
                    type="line"
                    height={320}
                    className="apex-charts"
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <CustomerDistribution />
        </Row>
        <Row className="mt-2" style={{ rowGap: "1.5rem" }}>
          <Col md="4">
            <Disputes />
          </Col>
          <Col md="8">
            <PurchaseRate />
          </Col>
        </Row>
      </div>
    </div>
  )
}
